'use strict';
var selectDirective = (function () {
    function selectDirective($timeout, $parse) {
        this.$timeout = $timeout;
        this.$parse = $parse;
        this.restrict = 'ACE';
    }
    selectDirective.prototype.link = function (scope, element, attrs) {
        var _this = this;
        var opt = {
            placeholder: attrs.placeholder || null,
            minimumResultsForSearch: attrs.single || null,
            width: attrs.width
        };
        this.$timeout(function () {
            element.select2(opt);
            element.select2Initialized = true;
        });
        var refreshSelect = function () {
            if (!element.select2Initialized)
                return;
            _this.$timeout(function () {
                element.trigger('change');
            });
        };
        var recreateSelect = function () {
            if (!element.select2Initialized)
                return;
            _this.$timeout(function () {
                element.select2('destroy');
                element.select2(opt);
            });
        };
        scope.$watch(attrs.ngModel, refreshSelect);
        if (attrs.ngOptions) {
            var list = attrs.ngOptions.match(/ in ([^ ]*)/)[1];
            // watch for option list change
            scope.$watch(list, recreateSelect);
        }
        if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refreshSelect);
        }
    };
    selectDirective.factory = function () {
        var directive = function ($timeout, $parse) { return new selectDirective($timeout, $parse); };
        directive.$inject = ['$timeout', '$parse'];
        return directive;
    };
    return selectDirective;
}());
angular
    .module('application')
    .directive('select', selectDirective.factory());

//# sourceMappingURL=select.js.map
